import { logEvent } from '@/analytics/events';
import EshopBoxes from '@/components/boxes/EshopBox/EshopBoxes';
import { type EshopBox } from '@/components/boxes/EshopBox/types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import { Headline } from '@/components/typography';
interface Props {
  eshops: EshopBox[];
}
export function Recommendations(props: Props) {
  const {
    t
  } = useTranslation('discounts');
  const {
    ref,
    inView
  } = useInView({
    triggerOnce: true
  });
  useEffect(() => {
    if (inView) {
      if (!props.eshops) {
        return;
      }
      const items = props.eshops?.map((eshop, index) => ({
        promotion_id: 'affil_promo',
        promotion_name: eshop.image.title,
        creative_name: eshop.image.title,
        creative_slot: `recommended_${index + 1}`,
        location_id: eshop.link
      }));
      logEvent('view_promotion', {
        ecommerce: {
          items
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);
  return <section className="relative z-10 pt-20 lg:pt-40" ref={ref}>
			<Headline as="h2" variant="h4" className="mb-6 text-center lg:mb-12">
				{t('recommendation')}
			</Headline>

			<EshopBoxes eshops={props.eshops} boxSize="sm" />
		</section>;
}